module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/clients/clients-grid/clients-grid.component.css
// module id = ./src/app/masters/clients/clients-grid/clients-grid.component.css
// module chunks = main